'use strict';

var JSConstants = require('_core_ext/constants'),
    CSSConstants = require('_core_ext/cssconstants');

var timer = {
    id: null,
    clear: function () {
        if (this.id) {
            window.clearTimeout(this.id);
            delete this.id;
        }
    },
    start: function (duration, callback) {
        this.id = setTimeout(callback, duration);
    }
};

var cartTimer = {
    id: null,
    clear: function () {
        if (this.id) {
            window.clearTimeout(this.id);
            delete this.id;
        }
    },
    start: function (duration, callback) {
        this.id = setTimeout(callback, duration);
    }
};

var initialized;
var allowedPages = {
    quotaNotification: ['clp', 'product', 'search', 'storefront', 'orderconfirmation', 'storedetails', 'wishlist', 'cart']
};

function _showQuotaNotificationWrapper() {
    var $quotaWrapper = $(JSConstants.CLASS_QUOTA_NOTIFICATION);
    if ($quotaWrapper && $quotaWrapper.length) {
        setQuotaNotificationPosition();

        $quotaWrapper.show();
        $quotaWrapper.addClass(CSSConstants.M_ACTIVE);

        timer.start(20000, function() {
            closeQuotaNotification();
        });
    }
}

function setQuotaNotificationPosition() {
    var $miniCart = $(JSConstants.CLASS_HEADER_CART + ', ' + JSConstants.CLASS_MINICART);
    var $quotaWrapper = $(JSConstants.CLASS_QUOTA_NOTIFICATION);

    if ($miniCart.length && $quotaWrapper.length) {
        var miniCartOffset = $miniCart.offset();
        var miniCartWidth = $miniCart.outerWidth();
        var miniCartHeight = $miniCart.outerHeight();

        var rightPosition = $(window).width() - (miniCartOffset.left + miniCartWidth) + 10;
        var topPosition = miniCartOffset.top + miniCartHeight + 10;

        $quotaWrapper.css({
            '--notification-right': rightPosition + 'px',
            '--notification-top': topPosition + 'px'
        });

        toggleNotificationPointer($miniCart, $quotaWrapper);
    }
}

function toggleNotificationPointer($miniCart, $quotaWrapper) {
    if (!$miniCart.length || !$quotaWrapper.length) {
        return;
    }

    var miniCartOffset = $miniCart.offset();
    var miniCartHeight = $miniCart.outerHeight();
    var windowTop = $(window).scrollTop();
    var windowHeight = $(window).height();
    var windowBottom = windowTop + windowHeight;
    var miniCartTop = miniCartOffset.top;
    var miniCartBottom = miniCartTop + miniCartHeight;
    var isMinicartVisible = miniCartBottom >= windowTop && miniCartTop <= windowBottom;

    if (isMinicartVisible) {
        $quotaWrapper.removeClass(CSSConstants.M_NO_POINTER);
    } else {
        $quotaWrapper.addClass(CSSConstants.M_NO_POINTER);
    }
}

function closeQuotaNotification() {
    var $quotaWrapper = $(JSConstants.CLASS_QUOTA_NOTIFICATION);
    if ($quotaWrapper && $quotaWrapper.length) {
        $quotaWrapper.hide();
        $quotaWrapper.removeClass(CSSConstants.M_ACTIVE);

        $(JSConstants.CLASS_QUOTA_NOTIFICATION_ICON).removeClass(CSSConstants.M_FULL_BASKET);

        timer.clear();
    }
}

function hideCartQuotaError() {
    var $cartQuotaNotification = $(JSConstants.CLASS_CART_QUOTA_NOTIFICATION);
    if ($cartQuotaNotification && $cartQuotaNotification.length) {
        $cartQuotaNotification.removeClass(CSSConstants.M_ACTIVE);
        cartTimer.clear();
    }
}

function showCartQuotaError() {
    var $cartQuotaNotification = $(JSConstants.CLASS_CART_QUOTA_NOTIFICATION);
    if ($cartQuotaNotification && $cartQuotaNotification.length) {
        $cartQuotaNotification.addClass(CSSConstants.M_ACTIVE);

        // GA tracking for quota restriction
        $(document).trigger('cart.quotaReached', [false, 200, null, null, null]);

        cartTimer.start(20000, function() {
            hideCartQuotaError();
        });
    }
}

function initializeCartEvents() {
    $(document).on('click', JSConstants.CLASS_CART_QUOTA_NOTIFICATION + ' ' + JSConstants.CLASS_QUOTA_NOTIFICATION_CLOSE, function(e) {
        e.preventDefault();
        hideCartQuotaError();
    });

    $(document).on('click', JSConstants.CLASS_BASKET_FULL, function(e) {
        e.preventDefault();
        e.stopPropagation();
        showCartQuotaError();
    });
}

function showQuotaMessageNotification(message, quotaType) {
    var $msgWrapper = $(JSConstants.ID_QUOTA_NOTIFICATION);

    if (message && message.length) {
        showQuotaNotification($msgWrapper, message, quotaType, allowedPages.quotaNotification);
    }
}

function autoShowQuotaOnLoad() {
    var $quotaNotification = $(JSConstants.CLASS_QUOTA_NOTIFICATION);
    var hasWarningAttribute = $quotaNotification.attr('data-cart-quota-warning') === 'true';

    if (hasWarningAttribute) {
        var $msgWrapper = $(JSConstants.ID_QUOTA_NOTIFICATION);
        var message = $quotaNotification.attr('data-cart-quota-message');
        var quotaType = 'warning';

        showQuotaNotification($msgWrapper, message, quotaType, allowedPages.quotaNotification);
    }
}

function showQuotaNotification($elem, string, quotaType, pages) {
    var allowedPage = pages && pages.length && ~pages.indexOf(pageContext.ns);

    if ($elem && $elem.length && allowedPage) {
        $elem.find(JSConstants.CLASS_QUOTA_NOTIFICATION_TEXT).html(string);

        var $quotaIcon = $(JSConstants.CLASS_QUOTA_NOTIFICATION_ICON);
        var isMaximumMessage = quotaType === 'maximum';

        if (isMaximumMessage) {
            $quotaIcon.addClass(CSSConstants.M_FULL_BASKET);
        } else {
            $quotaIcon.removeClass(CSSConstants.M_FULL_BASKET);
        }

        _setQuotaVisibleOnly($elem);
        _showQuotaNotificationWrapper();
    }
}

function _setQuotaVisibleOnly($elem) {
    var $quotaWrapper = $(JSConstants.CLASS_QUOTA_NOTIFICATION);
    if ($quotaWrapper && $quotaWrapper.length) {
        $quotaWrapper.find(JSConstants.CLASS_QUOTA_NOTIFICATION_MSG).each(function() {
            var $cur = $(this);

            if ($elem && $cur.is($elem)) {
                $cur.show();
            } else {
                $cur.hide();
            }
        });
    }
}

function initializeEvents() {
    $(document).on('click', JSConstants.CLASS_QUOTA_NOTIFICATION_CLOSE, function() {
        closeQuotaNotification();
    });

    initializeCartEvents();

    $(window).on('resize orientationchange', function() {
        setQuotaNotificationPosition();
    });

    $(window).on('scroll', function() {
        var $miniCart = $(JSConstants.CLASS_HEADER_CART + ', ' + JSConstants.CLASS_MINICART);
        var $quotaWrapper = $(JSConstants.CLASS_QUOTA_NOTIFICATION);

        if (window.innerWidth >= 768) {
            toggleNotificationPointer($miniCart, $quotaWrapper);
        }
    });

    setTimeout(function() {
        setQuotaNotificationPosition();
    }, 100);
}

module.exports = {
    init: function() {
        if (initialized) {
            return;
        }
        initializeEvents();
        showCartQuotaError();
        autoShowQuotaOnLoad();
        initialized = true;
    },
    showMessage: showQuotaMessageNotification,
    close: closeQuotaNotification,
    showCartQuotaError: showCartQuotaError,
    hideCartQuotaError: hideCartQuotaError
};